'use client'
import { Navigate } from 'react-router-dom'
import { objectTypes } from '@/core/api/modules/document'
import { useGetMyInfosQuery } from '@/core/graphql/hooks'
import { getTranslations, useRouter } from '@/lib/next-shim'
import { ConsultationDetails } from './ConsultationDetails'
import { ConsultationDetailSkeleton } from './Skeletons'
import { useRequiredParams } from '@/hooks/useRequiredParams'

export function ConsultationPage() {
  const { consultationId } = useRequiredParams(['consultationId'])
  const router = useRouter()
  const t = getTranslations()

  const { data, loading, error } = useGetMyInfosQuery()
  const myInfos = data?.myInfos

  if (loading) {
    return (
      <div className="flex-1 overflow-auto">
        <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
          <ConsultationDetailSkeleton />
        </div>
      </div>
    )
  }
  if (error) return <div className="p-10 text-center text-red-500">{t('common.error', { message: error.message })}</div>

  const consultation = myInfos?.consultations.find((item) => item._id === consultationId)
  if (!consultation) return <Navigate to="/account/consultations" replace />

  const consultationFormSubmissions = (myInfos?.formSubmissions || []).filter((submission) => submission.consultation?._id === consultationId)

  const isFuture = new Date(consultation.startDate) > new Date()
  const handleClose = () => router.push(`/account/consultations?tab=${isFuture ? 'future' : 'past'}`)

  return (
    <div className="flex-1 overflow-auto">
      <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6 lg:px-8">
        <ConsultationDetails
          consultation={consultation}
          consultationFiles={consultation.files.map((file) => ({
            filename: file.filename,
            key: file.key,
            url: file.url || '',
          }))}
          consultationFormSubmissions={consultationFormSubmissions}
          documentsTitle={t('page.AccountConsultation.documents.title')}
          objectType={objectTypes[0]}
          objectId={consultation._id}
          onClose={handleClose}
        />
      </div>
    </div>
  )
}
